import React, { useState } from 'react'
import './index.less'
import { Form, Input, Button, message, Row, Col, Dropdown, Space } from 'antd'
import NavigationBar from '@/components/NavigationBar'
import { request } from "@/utils";
import { Func, rsaEncrypt } from "@/utils/func";
import { useNavigate } from "react-router-dom";
import { DownOutlined } from '@ant-design/icons';
import IconPswon from '@/assets/icon-psw-on.png'
import IconPswoff from '@/assets/icon-psw-off.png'
export default function ForgetPassword() {

    const navigate = useNavigate()
    const [countdown, setCountdown] = useState(60); // 初始倒计时值
    const [isCounting, setIsCounting] = useState(false); // 标志是否在倒计时中
    const [showPwd, setShowPwd] = useState(false)
    const [areCode, setAreaCode] = useState('86')
    const [params, setParams] = useState({ mobile: null, code: null, password: null })
    const items = [
        {
            key: '1',
            label: (
                <div className='arecode' onClick={() => { setAreaCode('86') }}>
                    <span className='code'> +86 </span><span>中国大陆</span>
                </div>
            ),
        },
        {
            key: '2',
            label: (
                <div className='arecode' onClick={() => { setAreaCode('852') }}>
                    <span className='code' > +852 </span><span>中国香港</span>
                </div>
            ),

        },
        {
            key: '3',
            label: (
                <div className='arecode' onClick={() => { setAreaCode('886') }}>
                    <span className='code'> +886 </span><span>中国台湾</span>
                </div>
            ),
        },
        {
            key: '4',
            label: (
                <div className='arecode' onClick={() => { setAreaCode(853) }}>
                    <span className='code'> +853 </span><span>中国澳门</span>
                </div>
            ),
        },
        {
            key: '5',
            label: (
                <div className='arecode' onClick={() => { setAreaCode(81) }}>
                    <span className='code'> +81 </span><span>日本</span>
                </div>
            ),
        }
    ];
    const startCountdown = () => {
        setIsCounting(true);
        const interval = setInterval(() => {
            setCountdown((prevCount) => {
                if (prevCount <= 1) {
                    clearInterval(interval);
                    setIsCounting(false);
                    setCountdown(60)
                }
                return prevCount - 1;
            });
        }, 1000);
    };
    const onFinish = () => {
        if (!areCode) {
            message.error('请选择区号')
            return false
        }
        if (!params.mobile) {
            message.error('请输入手机号码')
            return false
        }
        if (areCode == '86' && !/^1[3-9]\d{9}$/.test(params.mobile)) {
            message.error('请输入正确的手机号码')
            return false
        }
        if (!params.code) {
            message.error('请输入验证码')
            return false
        }
        if (!params.password) {
            message.error('请输入密码')
            return false
        }
        if (!/^(?=.*[0-9])(?=.*[a-zA-Z]).{8,15}$/.test(params.password)) {
            message.error('密码需包含字母和数字，长度为8-16位')
            return false
        }
        const postData = async () => {
            try {
                let pwd = await rsaEncrypt(params.password);
                const response = await request.post('auth/forget-pwd-web', {
                    mobile: params.mobile,
                    password: pwd,
                    code: params.code,
                });
                if (response.code) {
                    message.error(response.msg)
                } else {
                    message.success('密码修改成功')
                    navigate('/login')
                }
                console.log(response.data);
            } catch (error) {
                console.error('Failed to fetch data:', error);
            }
        };
        postData()
    };
    const handleSendCode = async () => {
        try {
            const phoneNumber = params.mobile;
            // 手机号码验证，你可以根据实际需求修改验证规则
            if (/^1[3-9]\d{9}$/.test(phoneNumber)) {
                const response = await request.post('auth/mobile-code', {
                    mobile: params.mobile,
                    type: 2,
                    nation_code: areCode
                });
                console.log(response, '999')
                if (response.code == 0) {
                    message.success('验证码已发送');
                    startCountdown();
                } else {
                    message.error(response.msg)
                }
                // 这里使用 setTimeout 模拟异步操作

            } else {
                message.error('请输入有效的手机号码');
            }
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
        }
    };
    return (
        <div className="forgetPassword">
            <NavigationBar showNavRight={false} showNavTabs={false}></NavigationBar>
            <div className="forgetPassword-container">
                <Button type="cancel" style={{ with: "74px", height: "32px", color: "#999999", borderRadius: "4px" }}
                    onClick={() => navigate(-1)}>
                    返回
                </Button>
                <div className='forgetPassword-header'>
                    忘记密码
                </div>
                <div className='label'>手机号码</div>
                <div className="phone-input mg20">
                    <Dropdown menu={{ items }} trigger={['click']}>
                        <div className='areaCode'>
                            <div className='codeValue' >+{areCode}</div>
                            <DownOutlined style={{ fontSize: '14px' }} />
                        </div>
                    </Dropdown>
                    <input placeholder="请输入手机号码" size="large" value={params.mobile} onInput={(e) => {
                        params.mobile = e.target.value
                        setParams({ ...params })
                    }} />
                </div>
                <div className='label'>手机验证码</div>
                <div className='sendCode'>
                    <div className="phone-input">
                        <input placeholder="请输入手机验证码" size="large" value={params.code} onInput={(e) => {
                            params.code = e.target.value.replace(/\s/g, '');
                            setParams({ ...params });
                        }} />

                    </div>
                    <Button
                        className='sender-code'
                        type="primary"
                        size="large"
                        onClick={handleSendCode}
                        disabled={isCounting}
                        style={{ backgroundColor: isCounting ? '#f9f5ef' : '', color: isCounting ? '#C59D60' : '' }}
                    > {isCounting ? `${countdown}S后重发` : '发送验证码'}</Button>
                </div>
                <div className='label'>密码</div>
                <div className="phone-input mg20">
                    <input placeholder="请输入密码" size="large" type={showPwd ? 'text' : "password"} value={params.password} onInput={(e) => {
                        params.password = e.target.value
                        setParams({ ...params })
                    }} ></input>
                    {
                        showPwd ? <img className="pwd-icon" src={IconPswon} alt="" onClick={() => { setShowPwd(false) }} /> :
                            <img className="pwd-icon" src={IconPswoff} alt="" onClick={() => { setShowPwd(true) }} />
                    }
                </div>
                <div className='forgetPassword-hint' >
                    新密码需包含字母和数字，长度为8-16位
                </div>
                <Button type="primary" htmlType="submit" onClick={onFinish} block className="forgetPassword-form-button" size="large">
                    确定
                </Button>


            </div>

        </div>
    )
}
